<template>
    <div class="content-transference-component">
        <div class="left accordion-header" @click="toggleTable">
            <WhiteLabel>
                <span class="negrito">
                <svg class="calendar-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
                </svg>
                Meus agendamentos
                <span class="accordion-icon" :class="{ 'arrow-up': isTableVisible, 'arrow-down': !isTableVisible }"></span>
                </span>
            </WhiteLabel>
        </div>
            <div class="col-12 col-md-12" v-show="isTableVisible">
                    <table class="table-custom">
                    <thead>
                        <tr>
                        <th scope="col">Valor</th>
                        <th scope="col">Destino</th>
                        <th scope="col">Parcelas</th>
                        <th scope="col">Frequência</th>
                        <th scope="col">Próx. transferência</th>
                        <th scope="col">Começando em</th>
                        <th scope="col">Termina em</th>
                        <th scope="col">Status</th>
                        <th scope="col" class="text-left"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(recurrence, index) in this.recurrences" :key="index">
                            <td class="td-custom">
                              <span>R$</span>
                              {{
                                recurrence.amount
                                | currency('', 2, {
                                  decimalSeparator: ',',
                                  thousandsSeparator: '.',})
                              }}</td>
                            <td class="td-custom">{{ recurrence.accountDestinationName }}</td>
                            <td>{{ recurrence.totalTransferred}} de {{ recurrence.repetitions }}</td>
                            <td>{{ translateFrequency(recurrence.frequency) }}</td>
                            <td>{{ formatDate(recurrence.nextTransferDate) }}</td>
                            <td>{{ formatDate(recurrence.startDate) }}</td>
                            <td>{{ formatDate(recurrence.endDate) }}</td>
                            <td>{{ translateStatus(recurrence.status) }}</td>
                            <td class="action-cell">
                                <WhiteLabel>
                                  <button class="kebab-button" @click="toggleDropdown(index, recurrence, $event)">
                                    <span class="dot"></span>
                                    <span class="dot"></span>
                                    <span class="dot"></span>
                                  </button>
                                </WhiteLabel>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="row justify-content-center mx-0" style="padding-top: 10px;">
                  <app-paginator
                    :count="count"
                    :perPage="perPage"
                    @exchange="turnPage"
                  />
                </div>
        </div>

            <DetailsRecurrence
              :recurrence="selectedRecurrence"
              :visible="isModalVisible"
              @close="closeModal"
            />

            <RemoveRecurrence
              :recurrence="selectedRecurrence"
              :visible="isRemoveModalVisible"
              @close="closeRemoveModal"
              @confirm-delete="confirmDeleteRecurrence"
            />
    <div
      v-if="dropdownIndex !== null"
      class="dropdown-global"
      :style="dropdownPosition"
    >
      <div @click="viewDetails(selectedRecurrence)">Ver detalhes</div>
      <div @click="deleteSequence(dropdownIndex)">Excluir sequência</div>
    </div>
    <div>
      <ModalBase
        :id="authCodeModalData.id"
        :title="'Cancelar Recorrência'"
        :hasFooter="false"
        size="modal-md"
      >
        <div slot="content">
          <AuthCodeModalSection
            :ref="authCodeModalData.id"
            :subSection="authCodeModalData.subSection"
            :email="preset.holder.email"
            :mobile="preset.holder.mobile"
            :type="'pix-cancel-recurrence'"
            lastButtonText="Cancelar"
            @code-ready="cancelRecurrence($event)"
            @auth-sent="onAuthSent"
          />
        </div>
      </ModalBase>
    </div>
    </div>
</template>

<script>
import DetailsRecurrence from '@/components/pix/recurrence/DetailsRecurrence.vue';
import RemoveRecurrence from '@/components/pix/recurrence/RemoveRecurrence.vue';
import PaymentAccountsApi from '@/services/v1/PaymentAccountsApi';
import AccountApi from '@/services/AccountApi';
import RecurrenceFilters from '@/models/RecurrenceFilters';
import ModalBase from '@/components/shared/ModalBase';
import AuthCodeModalSection from '@/components/shared/modal/AuthCodeModalSection';
import { Presets } from '@/models/Presets';
import WhiteLabel from '@/components/shared/WhiteLabel';
import AppPaginator from '@/components/theme/Paginator';
import moment from 'moment';

export default {
    name: 'AppListRecurrences',
    components: {
      DetailsRecurrence,
      RemoveRecurrence,
      AuthCodeModalSection,
      ModalBase,
      WhiteLabel,
      AppPaginator,
    },
    props: {
      dateFilter: {
        type: Object,
        default: () => ({
          startDate: moment().add(-7, 'days').format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
        }),
      },
    },
    data() {
      return {
          token: null,
          twoFactorAuthTaxDocument: null,
          twoFactorAuthPassword: null,
          twoFactorDocumentRegex: new RegExp('^[0-9]+$'),
          dropdownIndex: null,
          recurrences: [],
          filter: new RecurrenceFilters(),
          isModalVisible: false,
          isRemoveModalVisible: false,
          selectedRecurrence: null,
          selectedToRemoveRecurrence: null,
          dropdownPosition: {
            position: 'fixed',
            top: '0px',
            left: '0px',
            zIndex: 999999,
          },
          authCodeModalData: {
            id: 'authCodeModal',
            subSection: 'destination',
          },
          preset: new Presets(),
          isTableVisible: true,
          perPage: 5,
          count: 0,
      };
    },
    async mounted() {
      await this.presets();
      await this.getRecurrences();
      document.addEventListener('click', this.closeDropdownOnClickOutside);
    },
    beforeDestroy() {
      document.removeEventListener('click', this.closeDropdownOnClickOutside);
    },
    methods: {
    async turnPage(numberPage) {
      const fim = numberPage * this.perPage;
      const inicio = fim - this.perPage;
      this.filter.offset.index = inicio;
      await this.getRecurrences();
    },
      onAuthSent() {
        this.authCodeModalData.subSection = 'code';
      },
      closeDropdownOnClickOutside(event) {
        if (!event.target.closest('.action-cell') &&
            !event.target.closest('.dropdown-global')) {
          this.dropdownIndex = null;
        }
      },
      async getRecurrences() {
        const api = new PaymentAccountsApi();

        this.filter.startDate = this.dateFilter.startDate;
        this.filter.endDate = this.dateFilter.endDate;

        let data  = await api.getListRecurrences(this.filter);
        this.recurrences = data.data;
        this.count = data.count;

        this.recurrences = this.recurrences.slice(0, this.perPage);
      },
      openModal(recurrence) {
        if (recurrence) {
          this.selectedRecurrence = recurrence;
          this.isModalVisible = true;
        }
      },
      closeModal() {
        this.isModalVisible = false;
        this.selectedRecurrence = null;
      },
      formatDate(dateIso) {
        if (!dateIso) return '-';

        const date = new Date(dateIso);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
      },
      translateStatus(status) {
        const items = {
          InProgress: 'Em andamento',
          Canceled: 'Cancelado',
          Finished: 'Finalizado',
          Invalid: 'Inválido',
        };

        return items[status] || '';
      },
      translateFrequency(freq) {
        const translations = {
          Weekly: 'Semanal',
          Biweekly: 'Quinzenal',
          Monthly: 'Mensal',
          Quarterly: 'Trimestral',
          SixMonthly: 'Semestral',
          Yearly: 'Anual',
        };
        return translations[freq] || '';
      },
      toggleDropdown(index, recurrence, event) {
        this.dropdownIndex = this.dropdownIndex === index ? null : index;

        if (this.dropdownIndex !== null) {
          this.selectedRecurrence = recurrence;

          if (event && event.target) {
            const button = event.target.closest('.kebab-button');
            if (button) {
              const rect = button.getBoundingClientRect();

              const top = rect.bottom + 5;
              const left = rect.right - 160;

              const finalTop = Math.max(10, top);
              const finalLeft = Math.max(10, Math.min(left, window.innerWidth - 170));

              this.dropdownPosition = {
                position: 'fixed',
                top: `${finalTop}px`,
                left: `${finalLeft}px`,
                zIndex: 999999,
              };
            }
          }
        }
      },
      viewDetails(recurrence) {
        this.openModal(recurrence);
        this.dropdownIndex = null;
      },
      deleteSequence(index) {
        this.isRemoveModalVisible = true;
        this.dropdownIndex = null;
      },
      closeRemoveModal() {
        this.isRemoveModalVisible = false;
      },
      async confirmDeleteRecurrence(recurrence) {
        try {
          $(`#${this.authCodeModalData.id}`).modal('show');
        } catch (error) {
          alert('Erro ao excluir a sequência. Tente novamente.');
        }
      },
      async cancelRecurrence(authCode) {
        var paymentAccApi = new PaymentAccountsApi();
        var recurrenceResponse = await paymentAccApi.cancelRecurrence(
          this.selectedRecurrence.recurrenceId,
          authCode
        );

        if (recurrenceResponse.status === 204) {
          $(`#${this.authCodeModalData.id}`).modal('hide');
          this.$alert.info('Pronto', 'Pagamento realizado com sucesso!');
        } else {
          this.$alert.error(
            'Ops',
            'Ocorreu um erro ao cancelar a recorrência.'
          );

          this.authCodeModalData.subSection = 'destination';
          this.$refs.authCodeModal.reset();
        }

        $(`#${this.authCodeModalData.id}`).modal('hide');
      },
      async presets() {
        try {
          const api = new AccountApi();
          this.preset = await api.presets();
        } catch (error) { }
      },
      toggleTable() {
        this.isTableVisible = !this.isTableVisible;
      },
    },
    watch: {
      dateFilter: {
        handler(newValue) {
          if (newValue && newValue.startDate && newValue.endDate) {
            this.getRecurrences();
          }
        },
        deep: true,
        immediate: false,
      },
    },
};
</script>

<style>
.negrito {
  font-weight: bold;
}

.accordion-header {
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 8px;
  padding: 8px 12px;
  user-select: none;
}

.accordion-header:hover {
  background-color: #f8f9fa;
}

.accordion-icon {
  margin-left: 10px;
  display: inline-block;
  width: 8px;
  height: 8px;
  border-right: 2px solid #6c757d;
  border-bottom: 2px solid #6c757d;
  transition: all 0.3s ease;
  position: relative;
  top: -2px;
}

.accordion-icon.arrow-down {
  transform: rotate(45deg);
}

.accordion-icon.arrow-up {
  transform: rotate(-135deg);
}

.calendar-icon {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  color: currentColor;
  vertical-align: middle;
  display: inline-block;
}

.table-custom {
  transition: opacity 0.3s ease, height 0.3s ease;
}

.table-custom {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: #5A5A5A;
}

.table-custom thead tr {
  background-color: #F7F7F7;
  border-radius: 10px 10px 0 0;
  display: table;
  width: 100%;
  table-layout: fixed;
}

.table-custom thead th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: #8E8E8E;
  user-select: none;
}

.table-custom thead th:first-child {
  border-radius: 10px 0 0 0;
}

.table-custom thead th:last-child {
  border-radius: 0 10px 0 0;
  width: 40px;
  text-align: center;
}

.table-custom tbody {
  display: block;
  max-height: 300px;
  overflow-y: auto;
}

.table-custom tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  background-color: #fff;
  border-bottom: 1px solid #E0E0E0;
  cursor: default;
}

.table-custom tbody tr:nth-child(even) {
  background-color: #FAFAFA;
}

.table-custom tbody td {
  padding: 12px 16px;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table-custom tbody td:first-child {
  font-weight: 700;
  color: #212121;
}

.td-custom {
  font-weight: 700;
  color: #212121;
}

.table-custom tbody td:last-child {
  text-align: center;
  width: 40px;
  position: relative;
}

.table-custom .action-button {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  color: #999999;
}

.table-custom .action-button:hover {
  color: #666666;
}

.table-custom .dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  box-shadow: 0 2px 6px rgb(0 0 0 / 0.15);
  border-radius: 6px;
  padding: 8px 0;
  min-width: 140px;
  font-size: 14px;
  color: #333;
  display: none;
  z-index: 10;
}

.table-custom .dropdown-menu.show {
  display: block;
}

.table-custom .dropdown-menu li {
  list-style: none;
  padding: 8px 16px;
  cursor: pointer;
}

.table-custom .dropdown-menu li:hover {
  background-color: #F0F0F0;
}

.dropdown-menu {
  position: absolute;
  top: 30px;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  list-style: none;
  padding: 8px 0;
  margin: 0;
  min-width: 160px;
  z-index: 100;
}

.dropdown-menu li {
  padding: 10px 16px;
  cursor: pointer;
  white-space: nowrap;
  color: #333;
  transition: background 0.2s;
}

.dropdown-menu li:hover {
  background-color: #f5f5f5;
}

.action-cell {
  position: relative;
  text-align: center;
  width: 40px;
  z-index: 1000;
}

.kebab-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 36px;
  border-radius: 6px;
  transition: background 0.2s;
}

.kebab-button:hover {
  background-color: #f0f0f0;
}

.kebab-button .dot {
  width: 4px;
  height: 4px;
  background-color: #666;
  border-radius: 50%;
}

.dropdown-global {
  background: white !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3) !important;
  border: 1px solid #ddd !important;
  min-width: 160px !important;
  max-width: 200px !important;
  overflow: hidden !important;
  position: fixed !important;
  z-index: 999999 !important;
}

.dropdown-global div {
  padding: 12px 16px !important;
  cursor: pointer !important;
  color: #333 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  transition: background-color 0.2s !important;
  background: white !important;
  border: none !important;
  display: block !important;
  white-space: nowrap !important;
}

.dropdown-global div:hover {
  background-color: #f0f0f0 !important;
}

.dropdown-global div:first-child {
  border-bottom: 1px solid #eee !important;
}

.dropdown-global div:last-child {
  border-bottom: none !important;
}
</style>
